import { importTypes } from '../../config/import';

export const urlKeys = {
  flats: 'FlatsGrid',
  // meters: 'HousingStock/house/{houseId}/meters',
};

const flatsDataTriggers = new Set([
  importTypes.owners,
  importTypes.personalAccounts,
  importTypes.individualMeters,
]);

export const isQueryEnabled = {
  [urlKeys.flats]: (type) => flatsDataTriggers.has(type),
  // [urlKeys.meters]: (type) => type === importTypes.individualMeters,
};

export const baseErrMsg =
  'Не удалось получить данные от сервера, необходимые для проверки файла.';
